<header>
  <h3>Validation Summary</h3>
</header>

<main>
  <mat-list>
    <ng-container *ngFor="let validation of errors">
      <sd-portal-error-summary-item [validationSummary]="validation" (controlSelected)="dismiss()">
      </sd-portal-error-summary-item>
    </ng-container>
  </mat-list>
</main>
